(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-list"]) return;
  try {
    
  function moveLatestProductsFirst() {
    const links = document.querySelectorAll(
      'a[href*="/collections/latest-products"]'
    );

    links.forEach(function(link) {
      const item = link.closest('.resource-list__item');

      if (!item) {
        return;
      }

      const parent = item.parentElement;

      if (parent && parent.firstElementChild !== item) {
        parent.insertBefore(item, parent.firstElementChild);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveLatestProductsFirst);
  } else {
    moveLatestProductsFirst();
  }

  document.addEventListener('shopify:section:load', moveLatestProductsFirst);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
